export const DOMAIN = "https://rugaciunidimineata.ro"
